import Span from "@vfuk/core-span";

export const FixedSpan = ({
  children = <></>,
  ...props
}: Omit<React.ComponentProps<typeof Span>, "children"> & {
  children?: JSX.Element;
}) => <Span {...props}>{children}</Span>;
